/** @format */
import {ReactNode, MouseEvent} from 'react';

import {Button, ButtonBase} from '@mui/material';

import {Link} from 'react-router-dom';

import clsx from 'clsx';

import {useStyles} from './styles';

type Props = {
  children: ReactNode;
  active?: boolean;
  selected?: boolean;
  to?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
};

const HeaderMenuButton = ({children, active, selected, to, onClick}: Props) => {
  const classes = useStyles();

  if (!to) {
    return (
      <Button
        className={clsx(classes.root, {
          [classes.selected]: selected,
          [classes.active]: active,
        })}
        disableRipple
        onClick={onClick}
      >
        {children}
      </Button>
    );
  }

  return (
    <ButtonBase
      className={clsx(classes.root, {
        [classes.selected]: selected,
        [classes.active]: active,
      })}
      disableRipple
      component={Link}
      to={to}
      onClick={onClick}
    >
      {children}
    </ButtonBase>
  );
};

export {HeaderMenuButton};
